<template>
  <div :id="permission.key" class="my-1 p-3 permission rounded-lg">
    <div class="flex items-start">
      <a-switch
        :checked="modelValue"
        :disabled="disabled"
        class="mt-1.5 mr-4"
        size="small"
        @change="handleChange"
      />
      <div class="flex-1">
        <div class="flex justify-between items-start cursor-pointer" @click="isExpanded = !isExpanded">
          <div>
            <h3 class="text_color text-base font-medium">
              {{ permission.name }}
            </h3>
            <p class="text-sm secondary_color mt-1">
              {{ permission.description }}
            </p>
          </div>
          <ThemeImage
            v-if="hasExtraContent"
            :class="[
              'cursor-pointer',
              isExpanded ? 'rotate-[-90deg]' : 'rotate-90',
            ]"
            :icon="imageNames.CHEVRON_ARROW_RIGHT"

          />
        </div>
      </div>
    </div>
    <div v-if="isExpanded && hasExtraContent">
      <slot name="extra-content"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  permission: { type: Object, required: true },
  modelValue: { type: Boolean, required: true },
  disabled: { type: Boolean, default: false },
  hasExtraContent: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const isExpanded = ref(false);

const handleChange = (checked) => {
  emit("update:modelValue", checked);
};
</script>

<style scoped>
.permission {
  border: 1px solid var(--white-opacity-8);
}
</style>
